/**
 * Air Traffic Controller — settings page.
 *
 * Route: /prioritization/settings/atc-agent
 *
 * On the agent template since migration 932 (SPEC-custom-agent-template.md
 * T1/T2): the template's common settings page with the classify panel; custom
 * agents made on the same behavior get the same page. Its old settings table
 * (atc_agent_config) is retired — DEP-036.
 */

import { TemplateAgentSettings } from '../../../components/agents/TemplateAgentSettings';
import { AIR_TRAFFIC_CONTROLLER } from '../../../lib/ai/agentDefinitions';

export default function AirTrafficController() {
  return <TemplateAgentSettings def={AIR_TRAFFIC_CONTROLLER} />;
}
